import { render, staticRenderFns } from "./Forma50.vue?vue&type=template&id=5bdc3d1b&scoped=true&"
import script from "./Forma50.vue?vue&type=script&lang=js&"
export * from "./Forma50.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdc3d1b",
  null
  
)

export default component.exports